import getApiClient from '@/plugins/api'

export default {
    closeModals: function() {
        const id = this.id

        this.$refs[`order${id}`].$refs[`order${id}`].hide()
        this.$refs[`cancelOrder${id}`].$refs[`cancelOrder${id}`].hide()
    },

    openOrderModal: function(orderId) {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get(`/orders/${orderId}`)
            .then((response) => {
                self.$parent.orderDetails = response.data
                self.$parent.showOrderModal = true
            })
            .catch(() => {})
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    getTripCover: function(cover) {
        const baseUrl = process.env.VUE_APP_BASE_URL

        return `${baseUrl}/assets/img/fb_imgs/${cover}`

    },

    showTerms: function(termsId) {
        const self = this,
          api = getApiClient(self.$store)

        self.$store.commit('startLoading')
        api.get(termsId)
          .then(response => {
              self.$parent.agencyName = self.agencyName
              self.$parent.terms = response.data
              self.$parent.showTermsModal = true
          })
          .catch(() => {})
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    }
}
